import moment from 'moment-timezone';
import { findIana } from 'windows-iana';

/**
 * Resolve a Windows timezone id (e.g. "US Eastern Standard Time") to an IANA name
 * (e.g. "America/Indianapolis") using the CLDR map shipped with the windows-iana
 * package. Covers every Windows tz id MS Graph can emit. Logs a warning when an
 * id isn't in the map so we notice drift instead of silently misinterpreting it.
 */
function resolveIana(windowsTzId) {
    if (!windowsTzId) return null;
    const list = findIana(windowsTzId);
    const iana = Array.isArray(list) ? list[0] : null;
    if (!iana && typeof console !== 'undefined' && console.warn) {
        console.warn(
            '[TimezoneUtils] Unknown Windows tz id: "' + windowsTzId + '" — falling back to UTC.'
        );
    }
    return iana;
}

/**
 * Interpret a naive datetime in the given Windows timezone and return a
 * timezone-aware moment. Unknown/missing tz ids fall back to UTC (deterministic)
 * rather than browser-local time, so live/past classification never depends on
 * who is looking at the page.
 */
export function getWebinarMoment(naiveDatetime, windowsTzId) {
    if (!naiveDatetime) return null;

    const iana = resolveIana(windowsTzId);

    // Strip trailing Z that Sequelize adds to naive datetime values — without
    // this, moment.tz would interpret the value as UTC instead of the source tz.
    const clean = String(naiveDatetime).replace(/Z$/i, '');
    return moment.tz(clean, iana || 'UTC');
}

/**
 * Convert a naive webinar datetime to the user's browser timezone.
 * Returns { formatted, tzAbbr } where tzAbbr is the abbreviation in the user's timezone.
 */
export function convertWebinarTime(naiveDatetime, windowsTzId, format) {
    const m = getWebinarMoment(naiveDatetime, windowsTzId);
    if (!m || !m.isValid()) return { formatted: '', tzAbbr: '' };

    const browserTz = moment.tz.guess();
    const local = m.tz(browserTz);

    return {
        formatted: local.format(format),
        tzAbbr: local.format('z'),
    };
}



// WEBPACK FOOTER //
// ./src/utils/TimezoneUtils.js